import { useState, useEffect } from 'react';
import { Select, MenuItem, FormControl, InputLabel,TextField, Button } from '@mui/material';
import styled from "styled-components";
import DownloadIcon from "@mui/icons-material/Download";

const FilterActionContainer = styled.div`
	padding: 16px 16px 0 16px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

const ExportContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: right;
`;

const FilterContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

const FilterItem = styled.div`
	margin-right: 10px;
	width: 200px;
`;

const FilterLabel = styled.div`
	font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
	font-size: 0.9rem;
	font-weight: 500;
	margin: 0 0 5px 0;
`;

const ButtonContainer = styled.div`
	margin-top:25px;
`;

export const VouchersFilter = (props) => {
	const { value, onSelectChangeHandler, onSearchClickHandler, onSearchChangeHandler, onResetClickHandler, downloadUrl, width, disabled, variant, label, background, compactView } = props;
	const [searchFields, setSearchFieldssetCountries] = useState([
	{
		"fieldName": "voucher_deep_link",
		"fieldDisplayName": "Deep Link"
	}]);

	return (
		<FilterActionContainer>
			<FilterContainer>
				{/* Search By Select Box */}
				<FilterItem>
					<FilterLabel>Search By</FilterLabel>
					<FormControl variant={"filled"} sx={{ width: '100%' }}>
						<InputLabel id="demo-simple-select-label">Select Field</InputLabel>
						<Select
							onChange={onSelectChangeHandler}
							placeholder=""
							value={value}
							label={"label"}
							classes={''}>
							{searchFields.map(({ fieldName, fieldDisplayName }) => (
								<MenuItem value={fieldName} key={`option-id-${fieldName}`}>
									{fieldDisplayName}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</FilterItem>
				{/* Search Value Input Box */}
				<FilterItem>
						<FilterLabel>Value</FilterLabel>
					<TextField id="value" label="value" onChange={onSearchChangeHandler} size='medium'/>
				</FilterItem>
				{/* Search Button */}
				<FilterItem>
					<ButtonContainer>
						<Button variant="contained" type="submit" onClick={onSearchClickHandler}>Search</Button>&nbsp;&nbsp;
						<Button variant="outlined" onClick={onResetClickHandler}>Reset</Button>
					</ButtonContainer>
				</FilterItem>
			</FilterContainer>
			<ExportContainer>
				{/* Download CSV Button */}
				<Button variant="contained" color="primary" size="large" onClick={()=>{window.open(downloadUrl, "_blank", "noreferrer")}} startIcon={<DownloadIcon size="large" />} disableElevation>
					Download CSV
				</Button>
			</ExportContainer>
		</FilterActionContainer>
	);
};